import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout-only: gives the template editor routes an "Order workflows" crumb back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/workflows')({
  staticData: { crumb: 'common:nav.workflows' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  component: Outlet,
});
